import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4" data-id="element-71">
      <div className="max-w-7xl mx-auto" data-id="element-72">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-73">
          {/* Column 1 */}
          <div data-id="element-74">
            <div className="flex items-center gap-2 mb-4" data-id="element-75">
              <LockIcon className="w-5 h-5 text-green-400" data-id="element-76" />
              <h3 className="text-white font-bold" data-id="element-77">Pagamento Sicuro</h3>
            </div>
            <p className="text-sm mb-4" data-id="element-78">
              Tutti i pagamenti sono protetti con crittografia SSL a 256 bit. I
              tuoi dati sono al sicuro.
            </p>
            <PaymentBadges data-id="element-79" />
          </div>

          {/* Column 2 */}
          <div data-id="element-80">
            <h3 className="text-white font-bold mb-4" data-id="element-81">Link Utili</h3>
            <ul className="space-y-2 text-sm" data-id="element-82">
              <li data-id="element-83">
                <a href="#" className="hover:text-white transition-colors" data-id="element-84">
                  Termini e Condizioni
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-white transition-colors" data-id="element-86">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-87">
                <a href="#" className="hover:text-white transition-colors" data-id="element-88">
                  Informativa sui Cookie
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div data-id="element-89">
            <h3 className="text-white font-bold mb-4" data-id="element-90">Contattaci</h3>
            <div className="flex items-center gap-2 text-sm" data-id="element-91">
              <MailIcon className="w-5 h-5" data-id="element-92" />
              <a href="mailto:info@activapleno.com" className="hover:text-white transition-colors" data-id="element-93">
                info@activapleno.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 space-y-4 text-sm text-center" data-id="element-94">
          <p data-id="element-95">
            Questo è un prodotto digitale. Non verrà spedito alcun prodotto
            fisico. Dopo l'acquisto riceverai immediatamente l'accesso via
            email.
          </p>
          <p data-id="element-96">
            © {new Date().getFullYear()} Mega-Pack Yoga per Bambini. Tutti i
            diritti riservati.
          </p>
          <p className="text-xs" data-id="element-97">
            Questo sito non fa parte del sito web di Facebook o Facebook Inc.
            Inoltre, questo sito NON è approvato da Facebook in alcun modo.
            FACEBOOK è un marchio registrato di FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}